import * as React from "react";

function SvgHamburgerWhite(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path stroke="#fff" strokeWidth={2} d="M0 10h40M0 20h40M0 30h40" />
    </svg>
  );
}

export default SvgHamburgerWhite;
